import script from "./confirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./confirmation.vue?vue&type=script&setup=true&lang=ts"

import "./confirmation.vue?vue&type=style&index=0&id=65d6350b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d6350b"]])

export default __exports__